var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "match-done-full-screen-modal",
      attrs: {
        id: "match-done-modal",
        "header-class": "match-done-modal-header",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "match-done-modal-header-content step4 w-100" },
                [
                  _c("img", {
                    staticClass: "match-done-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-watcher-right.png")
                    }
                  })
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.onAddRIBClicked($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("add.RIB")))]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onEndClicked($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Finish")))]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("h1", {
        staticClass: "green-o page-title mb-4",
        domProps: {
          innerHTML: _vm._s(
            _vm.didInsist
              ? _vm.$t("verify.match.done.dialog.insist_title")
              : _vm.$t("verify.match.done.dialog.title")
          )
        }
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "content",
        domProps: {
          innerHTML: _vm._s(
            _vm.didInsist
              ? _vm.$t("verify.match.done.dialog.insist_description")
              : _vm.$t("verify.match.done.dialog.description")
          )
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f9800ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9800ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/MatchDoneModal.vue
// module id = FpwB
// module chunks = 0